//Libraries
import {React, Component} from 'react'


//screens & components
import Header from '../../components/Header/Header'

//assets
import NotFoundGif from '../../assets/404.gif'
import './Glyph.css';


class Glyph extends Component {
  constructor(props){
    super(props)
    this.state = {
      all_labels :  ['upsidedown', 'horns', 'hat', 'food', 'transformer', 'comet', 'spaceship', 'triangle', 'bird','smiley', 'zombie', 'ogre', 'shape', 'heart','circle', 'square', 'animal', 'alien', 'ape', 'bear', 'bull', 'cat', 'creature', 'crab', 'dog', 'frog', 'ghost', 'human', 'mouse', 'panda', 'robot', 'abstract', 'dark', 'holes', 'minimal', 'light', 'lowContrast', 'highContrast', 'xSymmetrical','twoTone', 'object', 'helmet', 'mask', 'skull', 'invader',  'tool', 'emoji',  'idk', 'face','eyes', 'mouth', 'ears','nose', 'bug','blob','slime','fox','plant','flower','bunny','android','jellyfish','mammal','reptile','skeleton','ogre'],
      glyphId: this.props.match.params.id,
      glyphImgUrl: NotFoundGif,
      glyphName: "Pixelglyphs",
      glyphOpenSeaLink: "https://opensea.io/assets/pixelglyphs",
      glyphLabels: [],
      glyphNotes: []
    }
  }


  componentDidMount(){
     
    //fetch a random glyph or fetch a users glyphs
    fetch(`https://jittery-river-production.up.railway.app/glyph/${this.props.match.params.id}`)
    .then(response=>response.json())
    .then(data=>{
       const labels = this.state.all_labels.filter(element=>data[element])
       const label_counts = labels.map(element=>{
           return(
               {"label":element, "count": data[element]}
           )})
       this.setState(
            {
                glyphImgUrl: data["image"],
                glyphName: data["name"],
                glyphOpenSeaLink: data["link"],
                glyphLabels : label_counts,
                glyphNotes: data["other"].split(",")
            }   
       )
    })
    
  }
  

  render(){
      // console.log(this.state.glyphLabels)
    return (
  
    <div className="Glyph">
    <Header/>
    <div style={{fontSize:"65px", margin:"20px 0px 0px 0px", fontWeight:"900", letterSpacing:"3px"}}>{this.state.glyphName}  <a style={{margin:"0px 0px -20px -20px", fontSize:34}} className="open-sea-link" href={this.state.glyphOpenSeaLink}>⤯</a></div>
    <div className="cols" style={{margin:"20px", display: "flex", flexWrap:"wrap", flex:"1"}}>
      <div style={{margin:"20px", marginBottom:"0px", width:"45%",  minWidth:"400px"}}>
            <img src={this.state.glyphImgUrl} style={{ width:"80%", borderRadius:"5px"}}/>
      </div>
      <div style={{fontSize:"30px", margin:"20px", marginBottom:"0px", width:"45%", minWidth:"350px"}}>
         <div style={{fontWeight:"900", fontSize:"35px"}}>votes:</div>
          <div>
            {this.state.glyphLabels.map(element=><div style={{margin:"5px"}}>{element["count"]} {element["label"]}</div>)}    
          </div>  
          <div style={{marginTop:"20px", fontWeight:"900",fontSize:"35px"}}>notes:</div>
          <div>
            {this.state.glyphNotes.map(element=><div style={{margin:"5px"}}>-{element}</div>)}    
          </div>    
    
      </div>
    
    </div>

    </div>
                              
    );
  
  }
}

export default Glyph;
